import PropTypes from 'prop-types';
import { memo } from 'react';
import alfa from '../logo/alfa.svg';
import alfa_v2 from '../logo/alfa_v2.svg';
import vsk from '../logo/vsk.svg';
import vsk_v2 from '../logo/vsk_v2.svg';
import vuso from '../logo/vuso.svg';
import incor from '../logo/incor.png';
import * as Styled from './Style';
export const IMAGE = {
  alfa,
  alfa_v2,
  vsk,
  vsk_v2,
  vuso,
  incor
};
export const HEIGHT = {
  vuso: 34,
  incor: 48
};
const InsuranceLogo = ({
  name
}) => /*#__PURE__*/React.createElement(Styled.Logo, {
  type: name,
  height: HEIGHT[name]
}, /*#__PURE__*/React.createElement("img", {
  role: "presentation",
  src: IMAGE[name],
  alt: name
}));
InsuranceLogo.propTypes = {
  /** Название страховой компании */name: PropTypes.string
};
export default /*#__PURE__*/memo(InsuranceLogo);